import { database } from "../firebase";

export const fetchAllLists = async (info) => {
  try {
    const allLists = [];
    const lists = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("lists")
      .orderBy("timestamp")
      .get();
    if (lists.size > 0) {
      lists.forEach((list) => {
        allLists.push({
          apiLink: list.data().apiLink,
          key: list.id,
          area: list.data().area,
          timestamp: list.data().timestamp,
          industries: list.data().industries,
          name: list.data().name,
          size: list.data().size,
          status: list.data().status,
        });
      });
    }
    return Promise.all(allLists).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteList = async (info) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("lists")
      .doc(info.id)
      .delete();
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const updateList = async (info) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("lists")
      .doc(info.list.id)
      .update({ name: info.list.name });
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteListArray = async (details) => {
  try {
    if (details && details.items.length > 0) {
      const deletions = [];
      details.items.forEach((id) => {
        const single = deleteSingleList({
          companyId: details.companyId,
          key: id,
        });
        deletions.push(single);
      });

      return Promise.all(deletions).then((result) => {
        return { error: null };
      });
    } else {
      throw new Error("Kunne ikke slette lister.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteSingleList = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("lists")
      .doc(details.key)
      .delete();
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};
